import PropTypes from 'prop-types';
import RecentSearchImpl from './recent-search.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View for recent search history.
 *
 * @class RecentSearch
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * Callback to notify on item click or removal.
 *
 * @param {string} item  - List item involved.
 * @callback Mojito.Applications.Sports.Search.RecentSearch.itemCallback
 */

/**
 * RecentSearch prop types.
 *
 * @property {Array<string>} items - Recent search items.
 * @property {Mojito.Applications.Sports.Search.RecentSearch.itemCallback} [onItemClick = ()=>{}] - Recent search item clicked callback.
 * @property {Mojito.Applications.Sports.Search.RecentSearch.itemCallback} [onItemRemoveClick = ()=>{}] - Recent search item remove clicked callback.
 * @memberof Mojito.Applications.Sports.Search.RecentSearch
 */
const propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    onItemClick: PropTypes.func,
    onItemRemoveClick: PropTypes.func,
};

const defaultProps = {
    onItemClick: noop,
    onItemRemoveClick: noop,
};

export default UIView('RecentSearch', RecentSearchImpl, propTypes, defaultProps);
